import { createAPI } from '../../common'

export default {
  // MediaCloudVideoPortal
  /* preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0bddpvout', 'post', config, {
      neverLoading: true
    }), */
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  getActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0benjo0qfsnjttjpot0bdujpot0dpmvno',
      'get',
      config
    ),
  postActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0benjo0qfsnjttjpot0bdujpot0dpmvno',
      'post',
      config
    ),

  //设置审核流程
  postAccountsFlow: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bddpvout0gmpx', 'post', config),
  //取消授权
  postUnauthorized: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bddpvout0vobvuipsj{fe', 'post', config),
  //账号彻底删除
  deleteAccounts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bddpvout0efmfuf', 'post', config),
  // 获取除了抖音的视频号账号
  getAllAccounts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bddpvout', 'get', config),
  // 获取除了抖音的视频号账号
  getAdminAccounts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bddpvout0benjo', 'get', config),
  // 获取除了抖音的视频号账号（授权页面
  getAdminAccounts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bddpvout0benjo', 'get', config),
  // 获取账号
  getDouyinQRCode: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0qspd0hfofsbufEpvzjoRSDpef',
      'post',
      config
    ),
  // 获取POI
  getDouyinLocation: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0mpdbujpo', 'get', config, {
      neverLoading: true
    }),
  // 获取Bilibili分区信息
  getBilibiliCategories: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bddpvout0cjmjcjmj0dbufhpsjft',
      'get',
      config
    ),
  // 批量获取视频稿稿件详情
  getVdArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0hfuBsujdmft', 'POST', config),
  getE5Flows: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0f60gmpxt', 'get', config),
  // 获取当前流程
  getAccountDetail: (config) => {
    let url = '/mediax-articlevideo/vd/accounts/' + config.id
    return createAPI(
      url,
      'GET',
      {},
      {
        isSimpleSecurity: true
      }
    )
  },
  getAuthorizeUrl: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bddpvout0bvuipsj{fVsm', 'get', config, {
      timeout: 30000,
      neverLoading: true,
      ...vconfig
    }),
  getDouyinAccountsAddCallback: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bddpvout0dbmmcbdl', 'get', config),
  // 写稿初始化
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0dsfbujpo0jojujbmj{bujpo',
      'get',
      config
    ),
  // 写稿保存
  postSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0dsfbuf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 获取稿件详情
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0efubjm', 'get', config),
  // 稿件详情
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0efubjm', 'GET', config),
  // 删除稿件
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0qspd0efmfuf', 'post', config),
  // 撤回稿件
  postArticleRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0qspd0sfwplf', 'post', config),
  // 稿件送审
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0qspd0usbotgfs', 'post', config),
  // 审核通过
  postArticlePass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0qspd0qbtt', 'post', config),
  // 校对完成
  postArticleProof: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0qspd0qsppg', 'post', config),
  // 稿件驳回
  postArticleReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0qspd0sfkfdu', 'post', config),
  // 稿件发布
  postArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0qspd0qvcmjti', 'post', config, {
      timeout: 90000
    }),
  // 稿件签发（暂无 但是视频号和其他稿库不同 签发和发布是两个接口
  postArticlesPublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0qspd0jttvf', 'post', config),
  // 获取发布状态
  getArticlesPublishStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0qvcmjtiTubuvt', 'GET', config),

  // 获取当前流程
  getOtherAccountDetail: (config) => {
    let url = '/mediax-articlevideo/mo/accounts/' + config.id
    return createAPI(
      url,
      'GET',
      {},
      {
        isSimpleSecurity: true
      }
    )
  },
  // 获取媒体号账号
  getOtherAccounts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bddpvout', 'get', config),
  // 获取媒体号账号(操作权限)
  getOtherAdminAccounts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bddpvout0benjo', 'get', config),
  // 添加账号（头条号
  postAccountsSave: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bddpvout0tbwf', 'post', config),
  //设置审核流程
  postOtherAccountsFlow: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bddpvout0gmpx', 'post', config),
  //取消授权
  postOtherUnauthorized: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bddpvout0vobvuipsj{fe', 'post', config),
  //账号彻底删除
  deleteOtherAccounts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bddpvout0efmfuf', 'post', config),
  getOtherAuthorizeUrl: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bddpvout0bvuipsj{fVsm', 'get', config, {
      timeout: 30000,
      neverLoading: true,
      ...vconfig
    }),

  // 写稿初始化
  getMoInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0dsfbujpo0jojujbmj{bujpo',
      'get',
      config
    ),
  // 写稿保存
  postMoSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0dsfbuf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 获取稿件详情
  getMoDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0efubjm', 'get', config),
  // 删除稿件
  postMoArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0efmfuf', 'post', config),
  // 撤回稿件
  postMoArticleRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0sfwplf', 'post', config),
  // 稿件送审
  postMoArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0usbotgfs', 'post', config),
  // 审核通过
  postMoArticlesPass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0qbtt', 'post', config),
  // 校对完成
  postMoArticlesProof: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0qsppg', 'post', config),
  // 稿件驳回
  postMoArticleReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0sfkfdu', 'post', config),
  // 稿件发布
  postMoArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0qvcmjti', 'post', config),
  // 稿件签发（暂无 但是视频号和其他稿库不同 签发和发布是两个接口
  postMoArticlesPublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qspd0jttvf', 'post', config),
  // 获取发布状态
  getMoArticlesPublishStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0np0bsujdmft0qvcmjtiTubuvt', 'GET', config),

  // 视频号-详情页操作权限
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0f60bdujpot0efubjmbdujpot', 'get', config),

  // 视频号-获取微信视频号稿件列表
  getWxArticleList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0qspd0xyBsujdmfMjtu',
      'get',
      config
    ),
  // 视频号-获取微信视频号稿件列表-删除
  postWxArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bsujdmft0qspd0xyBsujdmfEfmfuf',
      'post',
      config
    )
}
